import DOMPurify from 'dompurify';

/**
 * Safely sanitizes HTML content and returns it for use with dangerouslySetInnerHTML
 * @param html - Raw HTML content from CMS
 * @returns Sanitized HTML string safe for rendering
 */
export const sanitizeHtml = (html: string): string => {
  return DOMPurify.sanitize(html, {
    // Allow common formatting tags
    ALLOWED_TAGS: [
      'p',
      'br',
      'strong',
      'em',
      'u',
      'b',
      'i',
      'h1',
      'h2',
      'h3',
      'h4',
      'h5',
      'h6',
      'ul',
      'ol',
      'li',
      'blockquote',
      'a',
      'span',
      'div',
    ],
    // Allow common attributes
    ALLOWED_ATTR: ['href', 'class', 'id', 'style'],
    // Remove any scripts or dangerous content
    FORBID_TAGS: ['script', 'object', 'embed', 'iframe'],
    FORBID_ATTR: ['onclick', 'onload', 'onerror'],
  });
};

/**
 * Component wrapper for safely rendering HTML content
 * @param html - Raw HTML content
 * @param className - CSS classes to apply to the wrapper div
 * @returns React props object with dangerouslySetInnerHTML
 */
export const createSafeHtmlProps = (html: string, className?: string) => {
  return {
    className,
    dangerouslySetInnerHTML: { __html: sanitizeHtml(html) },
  };
};

/**
 * Strips HTML tags from text for use in plain text contexts (like truncated descriptions)
 * @param html - HTML content
 * @returns Plain text without HTML tags
 */
export const stripHtmlTags = (html: string): string => {
  return html.replace(/<[^>]*>/g, '');
};
